"use client";

import { useState } from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
  SidebarGroup,
  SidebarMenu,
} from "@focal/ui-kit";
import { ANALYTICS_EVENTS, routes } from "@/constants";
import { SidebarItem } from "@/components/common/AppSidebar/components/SidebarItem";
import { NavMenuDropdownItem } from "./NavMenuDropdownItem";
import { useBillingState } from "@/hooks/useBillingState";

export const NavAddMeeting = () => {
  const [open, setOpen] = useState(false);
  const { canAccessFeature } = useBillingState();
  const isIntegrationDisabled = !canAccessFeature("canAccessAdvancedFeatures");

  return (
    <SidebarGroup>
      <SidebarMenu>
        <DropdownMenu open={open} onOpenChange={setOpen}>
          <DropdownMenuTrigger>
            <SidebarItem
              icon={"AddBoxIcon"}
              url={"#"}
              title="Add meeting"
              className="max-w-[160px] [&>div>span]:text-primary! [&>div>svg]:fill-primary!"
            />
          </DropdownMenuTrigger>
          <DropdownMenuContent className="w-[260px] p-2" align="start">
            <NavMenuDropdownItem
              icon={"MicIcon"}
              title="Transcribe"
              subtitle="In-person meetings or dictations"
              url={routes.inPerson.index}
              disabled={isIntegrationDisabled}
              dataAttr={ANALYTICS_EVENTS.APP_NAV_TRANSCRIBE_NAV_CLICK}
              dataText="Start in-person transcription"
              resetOnNavigate
            />
            <NavMenuDropdownItem
              icon={"SendIcon"}
              title="Invite"
              subtitle="Add to a live video meeting"
              url={routes.videoMeeting.index}
              disabled={isIntegrationDisabled}
              dataAttr={ANALYTICS_EVENTS.APP_NAV_INVITE_NAV_CLICK}
              dataText="Invite to live video meeting"
              resetOnNavigate
            />
            <NavMenuDropdownItem
              icon={"UploadIcon"}
              title="Upload"
              subtitle="Audio files"
              url={routes.audioTranscription.index}
              disabled={isIntegrationDisabled}
              dataAttr={ANALYTICS_EVENTS.APP_NAV_UPLOAD_NAV_CLICK}
              dataText="Upload audio file"
              resetOnNavigate
            />
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenu>
    </SidebarGroup>
  );
};
